import { useState } from 'react';
import type { Project } from '../../types/crm';
import {
  downloadProjectReportPdf,
  type ProjectExportContext,
} from '../../lib/projectExport';

interface ProjectReportExportButtonProps {
  project: Project;
  ctx: ProjectExportContext;
}

export function ProjectReportExportButton({ project, ctx }: ProjectReportExportButtonProps) {
  const [busy, setBusy] = useState(false);

  async function handleExport() {
    setBusy(true);
    try {
      await downloadProjectReportPdf(project, ctx);
    } catch (err) {
      window.alert(err instanceof Error ? err.message : 'Could not generate PDF report.');
    } finally {
      setBusy(false);
    }
  }

  return (
    <button
      type="button"
      className="btn-secondary"
      disabled={busy}
      onClick={() => void handleExport()}
    >
      {busy ? 'Generating PDF…' : 'Download project report (PDF)'}
    </button>
  );
}
